export default __webpack_public_path__ + "static/media/welcome.479d7429.svg";